


























































































































import Vue, { PropType } from 'vue';
import * as InputValidation from '@/mixins/inputValidation';

import store from '@/store';

import { BaseOrganization, WebRequestStatus } from '@/models';

import PersistableItem from '@/components/PersistableItem.vue';

export default Vue.extend({
  components: {
    PersistableItem
  },

  props: {
    organization: {
      type: Object as PropType<BaseOrganization>,
      required: true
    }
  },

  data() {
    return {
      nameInput: this.organization.name,
      roleNameStudentInput: this.organization.roleNameStudent,
      roleNameStudentPluralInput: this.organization.roleNameStudentPlural,
      roleNameTeacherInput: this.organization.roleNameTeacher,
      roleNameTeacherPluralInput: this.organization.roleNameTeacherPlural
    };
  },

  computed: {
    status(): WebRequestStatus {
      return store.getters.org.status.orgUpdate();
    },

    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, 250, true);
    },

    unchanged(): boolean {
      // If validations have errors, do not mark as changed
      if (!this.nameValidation.valid) {
        return true;
      }

      return (
        this.nameInput === this.organization.name &&
        this.roleNameStudentInput == this.organization.roleNameStudent &&
        this.roleNameStudentPluralInput ==
          this.organization.roleNameStudentPlural &&
        this.roleNameTeacherInput == this.organization.roleNameTeacher &&
        this.roleNameTeacherPluralInput ==
          this.organization.roleNameTeacherPlural
      );
    },

    dirtyModel(): BaseOrganization {
      return {
        ...this.organization,
        name: this.nameInput,
        roleNameStudent: this.roleNameStudentInput,
        roleNameStudentPlural: this.roleNameStudentPluralInput,
        roleNameTeacher: this.roleNameTeacherInput,
        roleNameTeacherPlural: this.roleNameTeacherPluralInput
      };
    }
  },

  methods: {
    notifyChanged() {
      this.$emit('settings-changed', {
        dirty: !this.unchanged,
        model: this.dirtyModel
      });
    }
  }
});
